import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['iframe']
  static classes = ['hidden']

  connect() {
    window.addEventListener('video-modal:open', this.handleOpen)
  }

  disconnect() {
    window.removeEventListener('video-modal:open', this.handleOpen)
  }

  handleOpen = event => {
    const url = event.detail.url
    this.iframeTarget.src = `${url}?autoplay=1`
    this.element.classList.remove(...this.hiddenClasses)
  }

  close() {
    this.iframeTarget.src = ''
    this.element.classList.add(...this.hiddenClasses)
  }
}
